<section class="flex flex-col items-center gap-12">
  <div class="text-center">
    <h2 class="mb-4 text-3xl font-bold">Open Positions</h2>
    <p class="max-w-2xl text-lg text-gray-600">
      We're always looking for talented individuals to join our team.
    </p>
  </div>

  <div class="grid w-full grid-cols-1 gap-8">
    <!-- Developer Advocate Position -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.megaphone" class="mr-2" />
        <h3 class="text-xl font-bold">Developer Advocate</h3>
      </div>

      <div class="flex flex-wrap gap-2">
        <tui-chip size="s">
          <tui-icon icon="@tui.map-pin" class="mr-1" />
          Remote
        </tui-chip>
        <tui-chip size="s">
          <tui-icon icon="@tui.dollar-sign" class="mr-1" />
          €50,000 - €70,000
        </tui-chip>
        <tui-chip size="s">
          <tui-icon icon="@tui.trending-up" class="mr-1" />
          Junior to Mid-Level
        </tui-chip>
      </div>

      <div>
        <h4 class="mb-2 text-lg font-semibold">Description</h4>
        <p class="text-pretty text-lg">
          Join our team as a Developer Advocate and help developers build
          amazing mobile apps with our SDKs and services. You'll create content,
          speak at conferences, and engage with our developer community to drive
          adoption and success.
        </p>
      </div>

      <div>
        <h4 class="mb-2 text-lg font-semibold">Requirements</h4>
        <ul class="list-inside list-disc space-y-1 text-pretty text-lg">
          <li>Interest in developer advocacy and community engagement</li>
          <li>
            Basic to intermediate technical background in mobile development
            (iOS/Android, React Native, or Capacitor)
          </li>
          <li>Strong communication skills and comfort with public speaking</li>
          <li>
            Experience or interest in creating technical content, tutorials, or
            documentation
          </li>
          <li>
            Passion for helping developers succeed and building communities
          </li>
          <li>Willingness to learn new technologies and frameworks</li>
        </ul>
      </div>

      <div class="mt-2">
        <a
          tuiButton
          appearance="primary"
          size="m"
          type="button"
          [href]="
            'mailto:' + emailCareers + '?subject=Developer Advocate Position'
          "
        >
          Apply Now
        </a>
      </div>
    </div>

    <!-- General Interest -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.briefcase" class="mr-2" />
        <h3 class="text-xl font-bold">Don't See Your Role?</h3>
      </div>
      <p class="text-pretty text-lg">
        We're always interested in hearing from talented people who are
        passionate about mobile development.
      </p>
      <p class="text-pretty text-lg">
        Feel free to reach out to us at
        <a
          [href]="'mailto:' + emailCareers"
          class="text-blue-600 underline hover:text-blue-800"
        >
          {{ emailCareers }}</a
        >
        if you think you'd be a great fit for our team.
      </p>
    </div>
  </div>
</section>
